import { Component, OnInit, Input } from '@angular/core';
import { LayoutUtilsService } from 'src/app/core/layout-utils.service';

@Component({
    selector: 'qAvatar',
    templateUrl: './qavatar.component.html',
    styleUrls: ['./qavatar.component.scss']
})
export class qAvatarComponent implements OnInit {

    @Input() avatarText: string = "";
    @Input() textLength: number = 2;
    @Input() iconSet: string = "la";
    @Input() icon: string = "";
    @Input() bgColor: string = "";
    @Input() iconOnly: boolean = false;
    @Input() isOutlined: boolean = false;
    @Input() size: string = "md";

    avatarTextVal: string = "";
    avatarBgColor: string = "";

    constructor(
        private layoutUtilsService: LayoutUtilsService,
    ) { }

    ngOnInit(): void {
        
        if (this.textLength > 2) {
            this.textLength = 2;
        }
        this.avatarTextVal = this.avatarText.slice(0, this.textLength).toUpperCase();

        if (this.size != "md || lg || sm") {
            this.size == "md";
        }
    }

    getAvatarBg () {
        if (this.bgColor) {
            this.avatarBgColor = this.bgColor;
        } else
        {
            this.avatarBgColor = this.layoutUtilsService.getqAvatarColor(this.avatarText);
        }

        return this.avatarBgColor;
    }

}
